export default __webpack_public_path__ + "static/media/slide-Exchange.b63b0998.png";